// Autogenerated by `pnpm version-file`. DO NOT EDIT
export const VERSION = '1.0.0-beta.36';
